import React, { useState } from "react";
import AppButton from "../../../components/ui/AppButton";
import analyticsService from "../../../services/university-admin/analyticsService";
import { useNotification } from "../../../context/NotificationContext";
import { useTranslation } from "react-i18next";

const UMExportModal = ({ filters, onClose }) => {
  const { t } = useTranslation(["universityManager", "common"]);
  const [format, setFormat] = useState("PDF");
  const [loading, setLoading] = useState(false);
  const { showSuccess, showError } = useNotification();

  const handleExport = async () => {
    setLoading(true);
    const res = await analyticsService.exportAnalytics(filters, format);
    if (res.success) {
      showSuccess(t("analytics.exportModal.success"));
      onClose();
    } else {
      showError(t("analytics.exportModal.error"));
    }
    setLoading(false);
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '16px' }}>
          <div className="modal-header border-bottom-0 pb-0">
            <h5 className="modal-title fw-bold fs-4">{t("analytics.exportModal.title")}</h5>
            <button type="button" className="btn-close" onClick={onClose} disabled={loading}></button>
          </div>
          <div className="modal-body pt-2 text-center">
            <p className="text-muted mb-4">{t("analytics.exportModal.description")}</p>
            <div className="d-flex gap-3 justify-content-center mb-2">
              {['PDF', 'CSV', 'EXCEL'].map(f => (
                <div 
                  key={f} 
                  className={`card text-center p-3 border-2 ${format === f ? 'border-primary bg-primary bg-opacity-10 shadow-sm' : 'border-light'}`}
                  style={{ width: '100px', cursor: 'pointer', transition: 'all 0.2s', borderRadius: '12px' }}
                  onClick={() => setFormat(f)}
                >
                  <i className={`fas fa-file-${f === 'PDF' ? 'pdf text-danger' : f === 'CSV' ? 'csv text-info' : 'excel text-success'} fs-2 mb-2`}></i>
                  <span className="fw-semibold text-dark">{f}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="modal-footer border-top-0 justify-content-center pb-4">
            <AppButton variant="outline" onClick={onClose} disabled={loading}>{t("common:buttons.cancel")}</AppButton>
            <AppButton variant="primary" onClick={handleExport} disabled={loading} className="px-4">
              {loading ? <span className="spinner-border spinner-border-sm me-2"></span> : <i className="fas fa-download me-2"></i>}
              {t("analytics.exportModal.download")} {format}
            </AppButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UMExportModal;
